﻿export interface IEmailExcelId {
    id: number;
    emailTypeId: number;
    name: string;
}
